<div class="bg-image"></div>
<div class="row col-12 justify-content-center">
    <div class="row col-12 login-block">
        <div class="col-12 col-lg-6">
            <div class="col-12 text-center">
                <img src="assets/img/UnityC_RGB_app_72ppi.jpg" class="img-fluid" alt="UnityC Logo">
            </div>
            <div class="row col-12 padding-top-20 d-none d-lg-block login-page-text">
                <div>
                    <span class="primary">C</span>onnect
                    <span class="padding-left-10 padding-right-10">|</span>
                    <span class="primary">C</span>ollaborate
                    <span class="padding-left-10 padding-right-10">|</span>
                    <span class="primary">C</span>ommunity
                </div>
                <div class="padding-top-20 primary">
                    Your Secure Connection to Canadian Law Offices
                </div>
            </div>

        </div>
        <div class="col-12 col-lg-6">
            <div class="login-card">
                <form [formGroup]="formGroup">
                    <header *ngIf="!user?.passwordChangeRequired"><span>Set a new password</span></header>
                    <header *ngIf="user?.passwordChangeRequired"><span>Your password has expired, please set a new password</span></header>
                    <div>
                        <mat-form-field appearance="legacy" >
                            <mat-label>Password</mat-label>
                            <!-- To avoid autocomplete of the password field, make the field readonly while form loading. And make it editable once the field get focus -->
                            <!--https://stackoverflow.com/questions/17719174/autocomplete-off-is-not-working-when-the-input-type-is-password-and-make-the-->
                            <input matInput type="password" formControlName="password" required autocomplete="off" readonly onfocus="this.removeAttribute('readonly');" >
                            <mat-error *ngIf="formGroup.controls['password'].hasError('required')">Password is required</mat-error>
                            <mat-error *ngIf="formGroup.controls['password'].hasError('hasNumber')">Must have at least one number!.</mat-error>
                            <mat-error *ngIf="formGroup.controls['password'].hasError('hasSpecial')">Must have at least one special character.</mat-error>
                            <mat-error *ngIf="formGroup.controls['password'].hasError('hasCapitalCase')">Must have at least one uppercase letter.</mat-error>
                            <mat-error *ngIf="formGroup.controls['password'].hasError('minLength')">Must be at least 8 characters in length or greater.</mat-error>
                            <mat-error *ngIf="formGroup.controls['password'].hasError('allowedChar')">No spaces allowed.</mat-error>
                            <mat-error *ngIf="formGroup.controls['password'].hasError('allowedChar')">Allowed characters are: A to Z, a to z, 0 to 9 and special characters.</mat-error>
                            <mat-error *ngIf="formGroup.controls['password'].hasError('hasConsecutive')">Password cannot have more than 2 consecutive same letter, number or special character.</mat-error>
                        </mat-form-field>

                    </div>
                    <div>
                        <mat-form-field appearance="legacy" >
                            <mat-label>Confirm Password</mat-label>
                            <input matInput type="password" my-auto-focus formControlName="retypePassword" required autocomplete="off">
                            <mat-error *ngIf="formGroup.controls['retypePassword'].hasError('required')">Confirm Password is required</mat-error>
                            <mat-error *ngIf="formGroup.controls['retypePassword'].hasError('mustMatch')">Passwords don't match.</mat-error>
                        </mat-form-field>
                    </div>

                    <div class="login-btn padding-top-20">
                        <button class="bold-font col-12" mat-raised-button color="accent" (click)="updateUserProfile()">NEXT</button>
                    </div>

                </form>
            </div>

        </div>
    </div>
    <div  class="footer-block d-none d-lg-block justify-content-lg-center">
        <dp-footer></dp-footer>
    </div>
</div>

